import { LoadingButton } from '@mui/lab';
import { Autocomplete, Stack, TextField } from '@mui/material';
import Proptypes from 'prop-types';
import FileDownload from 'js-file-download';
import { format } from 'date-fns';

import { api as stockApi } from '../../store/domains/stock';
import Render from '../Render';
import { useInput } from '../../hooks/useInput';
import { useAutoCompleteState } from '../../hooks/useAutoCompleteState';

const IccidForm = ({ handleClose, hubId, isTransfer, isUnassign }) => {
  const [minId, handleChangeMinId] = useInput();
  const [maxId, handleChangeMaxId] = useInput();
  const [partnerId, handleChangeFromPartner] = useAutoCompleteState(isTransfer);
  const [toPartner, handleChangeToPartner] = useAutoCompleteState(isTransfer);

  const [postIccidWithRangeMutation, { isLoading }] = stockApi.usePostIccidWithRange();

  const [postIccidWithRangeUnassignMutation, { isLoading: isLoadingUnassign }] =
    stockApi.usePostIccidWithRangeUnassign();
  const [postIccidWithRangeTransferMutation, { isLoading: isLoadingTransfer }] =
    stockApi.usePostIccidWithRangeTransfer();

  const { data: posManagerOrganizations } = stockApi.useGetPosManagerOrganizations(hubId, {
    skip: !hubId,
  });
  const { data: posManagerPartners } = stockApi.useGetOrganizations(null, {
    skip: !isTransfer,
  });

  const onSubmit = () => {
    if (isUnassign) {
      postIccidWithRangeUnassignMutation({
        minId,
        maxId,
      })
        .unwrap()
        .then((response) => {
          const date = format(new Date(), 'yyyy-MM-dd-HH-mm-ss');
          FileDownload(response, `IccidAttachmentResult-${date}.xlsx`);
        })
        .finally(() => {
          handleClose();
        });
      return;
    }

    if (isTransfer) {
      postIccidWithRangeTransferMutation({
        minId,
        maxId,
        fromPartner: partnerId,
        toPartner,
      })
        .unwrap()
        .then((response) => {
          console.log(response);
          const date = format(new Date(), 'yyyy-MM-dd-HH-mm-ss');
          FileDownload(response, `IccidAttachmentResult-${date}.xlsx`);
        })
        .finally(() => {
          handleClose();
        });
      return;
    }

    postIccidWithRangeMutation({ minId, maxId, partnerId })
      .unwrap()
      .then((response) => {
        const date = format(new Date(), 'yyyy-MM-dd-HH-mm-ss');
        FileDownload(response, `IccidAttachmentResult-${date}.xlsx`);
      })
      .finally(() => {
        handleClose();
      });
  };
  return (
    <>
      <Stack spacing={3} sx={{ my: 2 }}>
        <TextField fullWidth placeholder="Min range" rows={4} value={minId} onChange={handleChangeMinId} />
      </Stack>
      <Stack spacing={3} sx={{ my: 2 }}>
        <TextField fullWidth rows={4} placeholder="Max range" value={maxId} onChange={handleChangeMaxId} />
      </Stack>
      <Render shouldRender={!isUnassign}>
        <Autocomplete
          value={partnerId}
          onChange={handleChangeFromPartner}
          options={posManagerOrganizations || []}
          renderInput={(params) => <TextField {...params} label="Select Partner" />}
          fullWidth
        />
      </Render>
      <Render shouldRender={isTransfer}>
        <Autocomplete
          value={toPartner}
          onChange={handleChangeToPartner}
          options={posManagerPartners || []}
          renderInput={(params) => <TextField {...params} label="Select Partner to transfer" />}
          fullWidth
          sx={{ mt: 2 }}
        />
      </Render>
      <LoadingButton
        sx={{ my: 2 }}
        onClick={onSubmit}
        fullWidth
        size="large"
        type="submit"
        variant="contained"
        loading={isLoading || isLoadingTransfer || isLoadingUnassign}
        disabled={isLoading || isLoadingTransfer || isLoadingUnassign}
      >
        Submit
      </LoadingButton>
    </>
  );
};
IccidForm.propTypes = {
  handleClose: Proptypes.func,
  hubId: Proptypes.number,
  isTransfer: Proptypes.bool,
  isUnassign: Proptypes.bool,
};
export default IccidForm;
